import * as R from 'ramda';
import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const store = (state) => state.templateReport;

const makeSelectUsedReport = () => createSelector(
  store,
  ({ usedReport }) => usedReport,
);

const makeSelectAvailableReports = () => createSelector(
  store,
  ({ availableReports }) => availableReports,
);

const makeSelectGlobalFilterValue = () => createSelector(
  store,
  ({ globalFilterValue }) => globalFilterValue,
);

const makeSelectPagination = () => createSelector(
  store,
  (templateReport) => R.path([templateReport.listType, 'pagination'], templateReport),
);

const makeSelectReportType = () => createSelector(
  store,
  ({ reportType }) => reportType,
);

const makeSelectItemList = () => createSelector(
  store,
  (templateReport) => R.compose(
    R.sortBy(R.prop('index')),
    R.values,
    R.pathOr([], [templateReport.listType, 'itemList']),
  )(templateReport),
);

const makeSelectTotalCount = () => createSelector(
  store,
  (templateReport) => R.path([templateReport.listType, 'totalCount'], templateReport),
);

const makeSelectListLoading = () => createSelector(
  store,
  ({ loading }) => loading,
);

const makeSelectReportStatus = () => createSelector(
  store,
  ({ reportPending }) => reportPending,
);

const makeSelectSelectedList = () => createSelector(
  store,
  (templateReport) => R.compose(
    R.keys,
    R.filter(({ selected }) => selected),
    R.pathOr([], [templateReport.listType, 'itemList']),
  )(templateReport),
);

const makeSelectTableTitleFilters = () => createSelector(
  store,
  (templateReport) => R.path([templateReport.listType, 'tableTitleFilters'], templateReport),
);

const makeSelectTitleSortValues = () => createSelector(
  store,
  (templateReport) => R.path([templateReport.listType, 'titleSortValues'], templateReport),
);

const makeSelectListType = () => createSelector(
  store,
  ({ listType }) => listType,
);

const makeSelectContainerTypes = () => createSelector(
  store,
  R.pathOr([], ['containerTypes']),
);

const makeSelectAccessorialConfigs = () => createSelector(
  store,
  ({ accessorialConfigs }) => accessorialConfigs,
);

const makeSelectBranchConfigs = () => createSelector(
  store,
  ({ branchConfigs }) => branchConfigs,
);

const makeSelectServiceVendorListAvailable = () => createSelector(
  store,
  ({ serviceVendorListAvailable }) => serviceVendorListAvailable,
);

const makeSelectAdditionalFilters = () => createSelector(
  store,
  ({ additionalFilters }) => additionalFilters,
);

export {
  makeSelectListType,
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectReportType,
  makeSelectListLoading,
  makeSelectReportStatus,
  makeSelectSelectedList,
  makeSelectBranchConfigs,
  makeSelectContainerTypes,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
  makeSelectGlobalFilterValue,
  makeSelectAdditionalFilters,
  makeSelectAccessorialConfigs,
  makeSelectServiceVendorListAvailable,
};
